import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-[45px]" }
const _hoisted_2 = { class: "w-full mb-[45px] px-8" }
const _hoisted_3 = { class: "w-full flex flex-col items-start gap-3" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "w-full" }


import QuestionnareButtonColor from "../parts/QuestionnareButtonColor.vue";
import QuestionnaireOutline from "../parts/QuestionnaireOutline.vue";

type Props = {
  appointmentCompletedButtonText: string;
  appointmentNotCompletedButtonText: string;
};

type Emits = {
  (event: "onSubmit", message: string): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'AbnahmeInitial',
  props: {
    appointmentCompletedButtonText: {},
    appointmentNotCompletedButtonText: {}
  },
  emits: ["onSubmit"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold pb-2" }, " Was the appointment completed? ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(QuestionnareButtonColor, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onSubmit', __props.appointmentCompletedButtonText))),
            "button-text": __props.appointmentCompletedButtonText
          }, null, 8, ["button-text"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(QuestionnaireOutline, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSubmit', __props.appointmentNotCompletedButtonText))),
            "button-text": __props.appointmentNotCompletedButtonText
          }, null, 8, ["button-text"])
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-full h-[48px] pt-3 border-t border-black/15" }, null, -1))
  ]))
}
}

})